var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_link",
    "data-name": "icon link",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Link",
    d: "M10.609,2A3.428,3.428,0,0,0,8.2,2.956l-.988.978a.561.561,0,0,0,0,.8.567.567,0,0,0,.8,0l.979-.97a2.286,2.286,0,0,1,3.24,3.225l-1.71,1.7a2.3,2.3,0,0,1-3.455-.246.564.564,0,0,0-.9.674,3.43,3.43,0,0,0,5.158.368L13.033,7.78l.007-.007A3.406,3.406,0,0,0,10.609,2ZM7.344,5.525a3.429,3.429,0,0,0-2.664.989L2.967,8.22l-.007.007A3.414,3.414,0,0,0,7.8,13.044l.984-.98a.561.561,0,0,0,0-.8.567.567,0,0,0-.8,0l-.973.969A2.286,2.286,0,0,1,3.77,9.012l1.71-1.7a2.3,2.3,0,0,1,3.455.246.564.564,0,0,0,.9-.674A3.425,3.425,0,0,0,7.344,5.525Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7721b3aca720a3192568bb6c82c9ef28.svg";
export { ForwardRef as ReactComponent };